import { createStore } from '@stencil/store';

import { IReportingToolsCurrentGroup, IReportingToolsUser } from '../models/typing';

export interface IReportingToolsBugInformation {
  userAgent: string;
  lang: string;
  pageUrl: string;
  console: string[];
  window: Window;
  user: IReportingToolsUser;
  group: IReportingToolsCurrentGroup;
  screenSize: Screen;
  project: string;
}

const { state } = createStore<IReportingToolsBugInformation>({
  userAgent: null,
  lang: null,
  pageUrl: null,
  console: null,
  window: null,
  user: null,
  group: null,
  screenSize: null,
  project: null,
});

export default state;
